module.exports = __webpack_public_path__ + "img/aboutus_bg.f288d190.png";